import { roles } from "../../../helpers/utils/Constants/roles";

export const onBoardingMenus = [
  {
    id: 1,
    name: "User Dashboard",
    value: "user_dashboard",
  },
  {
    id: 2,
    name: "Self Paced Scrum Master",
    value: "self_paced_scrum_master",
  },
  {
    id: 3,
    name: "Self Paced Product Manager",
    value: "self_paced_product_manager",
  },
  {
    id: 4,
    name: "Self Paced Agile Project Manager",
    value: roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT,
  },
  {
    id: 5,
    name: "AI Business Analyst",
    value: roles.AI_BUSINESS_ANALYST_STUDENT,
  },
  {
    id: 6,
    name: "Self Paced AI Product Owner",
    value: "self_paced_product_owner",
  },
  {
    id: 7,
    name: "Self Paced Business Analyst",
    value: "self_paced_business_analyst",
  },
];